<template>
    <div class="mb-3" v-if="has_nutrition">
        <h3>Nutrition</h3>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li
                    class="list-group-item"
                    v-for="nutrient in nutrition"
                    :key="nutrient"
                >
                    {{ nutrient }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecipeNutrition",
    props: ["recipe"],
    data() {
        return {
            nutrition: this.recipe.nutrition,
            has_nutrition: this.recipe.nutrition.length > 0,
        };
    },
};
</script>
<style scoped></style>
